const loader = {
    show: function () {
        document.body.appendChild(createLoader());
    },
    hide: function () {
        let loader = document.body.querySelector('.global_loader_cover');
        if (loader !== null && loader !== undefined) {
            document.body.removeChild(document.querySelector('.global_loader_cover'));
        }
    }
}

function createLoader() {
    let loaderCover = document.createElement('div');
    loaderCover.classList.add('global_loader_cover');
    loaderCover.insertAdjacentHTML('afterbegin', `
            <div class="sm-loader" role="status" aria-label="Loading"></div>
     `);

    return loaderCover;
}

module.exports = loader;